import {
    UPDATE_SPOT_LIST_REQUEST,
    updateSpotListSuccess,
    updateSpotListFailure,
    showSuccessNotification
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const updateSpotListEpic: TEpic = (action$, store$, { SpotListRepository }) => {
    return action$.pipe(
        ofType(UPDATE_SPOT_LIST_REQUEST),
        mergeMap(action => from(SpotListRepository.update( action.payload.id, action.payload.updateData ))
            .pipe(
                mergeMap((spotList) => {
                    return from([
                        showSuccessNotification(`Die Speicherung der SpotLists erfolgreich.`),
                        updateSpotListSuccess(spotList),
                    ]);
                }),
                catchError( error => {
                    return from([
                        updateSpotListFailure(error)
                    ])
                })
            )
        ),
    );
}
